<div class="reservation-card-container">
    <div class="reservation-card">
        <div class="reservation-image-col">
            <img [src]="'./assets/images/icons/file_check_card.png'" [alt]="reservation.eventName" class="reservation-image">
        </div>

        <div class="reservation-content-col">
            <div class="col-header">
                <h3 class="reservation-title pointer" (click)="details()">
                    <span>
                        <strong>{{ reservation.eventName }}</strong>                        
                    </span>
                </h3>

                <div class="right-side">
                    <!-- Status badge -->
                    <div class="status-badge">
                        <span class="status-dot" [ngClass]="getReservationAdminStatusClass()"></span>
                        <span class="status-text">{{ getReservationAdminStatusText() }}</span>
                    </div>

                    <!-- Action buttons -->
                    <div class="action-buttons" *ngIf="!isPerformingAction">
                        @if(reservation.offers && reservation.offers.length == 1){
                        <!-- Accept Offer Button -->
                        <button *ngIf="actionState?.canAcceptOffer" class="action-btn accept-btn" [title]="getActionButtonText('accept')" (click)="acceptOffer()">
                            <img src="./assets/images/icons/check-circle.svg" alt="Accept">
                            <span>{{ getActionButtonText('accept') }}</span>
                        </button>

                        <!-- Reject Offer Button -->
                        <button *ngIf="actionState?.canRejectOffer" class="action-btn reject-btn" [title]="getActionButtonText('reject')" (click)="rejectOffer()">
                            <img src="./assets/images/icons/x-circle.svg" alt="Reject">
                            <span>{{ getActionButtonText('reject') }}</span>
                        </button>

                        <!-- Request New Offer Button -->
                        <button *ngIf="actionState.canRequestNewOffer" class="action-btn request-new-btn" [title]="getActionButtonText('request_new')" (click)="requestNewOffer()">
                            <span>{{ getActionButtonText('request_new') }}</span>
                        </button> }
                        <!-- Update Reservation Button -->
                        <button *ngIf="actionState?.canUpdateReservation" class="action-btn update-btn" [title]="getActionButtonText('update')" (click)="updateReservation()">
                            <img src="./assets/images/icons/edit.png" alt="Edit">
                            <span>{{ getActionButtonText('update') }}</span>
                        </button>
                        <!-- Menu button for additional actions -->
                        <div class="menu-container">
                            <button class="card-menu-btn" (click)="toggleMenu($event)">
                                <img src="./assets/images/icons/menu-drop.png" alt="Menu">
                            </button>
                        </div>
                    </div>

                    <!-- Loading indicator -->
                    <div class="loading-indicator" *ngIf="isPerformingAction">
                        <div class="spinner"></div>
                        <span>{{ getLoadingText() }}</span>
                    </div>
                </div>
            </div>

            <div class="reservation-footer">
                <div class="info-col">
                    <div class="data">
                        <img src="./assets/images/icons/user_card_id_gray.png" alt="user_card_id icon">
                        <span>{{ reservation.requiredAgents }}</span>
                    </div>
                    <div class="data">
                        <img src="./assets/images/icons/calendar_calendar_event_gray.png" alt="calendar_calendar_event_gray icon">
                        <span>{{ reservation.startDateTime }} @if(reservation.endDateTime){ <span class="end-time"> - {{reservation.endDateTime}}</span> }</span>
                    </div>
                    <div class="data">
                        <img src="./assets/images/icons/map_pin_gray.png" alt="map_pin_gray icon">
                        <span>{{ formatAddress() }}</span>
                    </div>
                    <!--<div class="data">
                        {{ reservation.createdAt }}
                    </div>-->
                </div>
                @if(actionState.showSingleOfferPrice && actionState.singleOfferPrice){
                <div class="single-offer-price">
                    <span>{{ actionState.singleOfferPrice }}</span>
                </div>} @if(reservation.offers && reservation.offers.length > 1){
                <div class="many-offers">
                    <span>{{reservation.offers.length}} offre(s)</span>
                </div>
                } @if(!reservation.offers) {
                <div class="single-offer-price">
                    <span>-- €</span>
                </div>
                }
            </div>
        </div>
    </div>

    <div class="popup-menu" *ngIf="menuOpen">
        <div class="arrow"></div>
        <ul>
            <li (click)="details()">
                <img src="./assets/images/icons/eye.png" alt="Details" width="13px"> Details
            </li>
            <li *ngIf="actionState?.canSeeFeedbackDetails" (click)="feedbackDetails()">
                <img src="./assets/images/icons/eye.png" alt="Details" width="13px"> {{ getActionButtonText('see_feedback') }}
            </li>
            <li *ngIf="actionState?.canCancelReservation" (click)="cancelReservation()">
                <img src="./assets/images/icons/x.svg" alt="Cancel"> {{ getActionButtonText('cancel') }}
            </li>
            <li *ngIf="actionState?.canDeleteReservation" (click)="deleteReservation()" class="delete-item">
                <img src="./assets/images/icons/trash.png" alt="Delete"> {{ getActionButtonText('delete') }}
            </li>
        </ul>
    </div>
</div>

<!-- Delete Confirmation Modal -->
<div class="confirmation-modal-overlay" *ngIf="showDeleteModal" (click)="closeDeleteModal()">
    <div class="confirmation-modal" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h3 class="modal-title">Confirmer la suppression</h3>
            <button class="close-button" (click)="closeDeleteModal()">×</button>
        </div>
        <div class="modal-body">
            <p class="">Êtes-vous sûr de vouloir supprimer cette réservation ?</p>
            <p class="warning-text">Cette action est irréversible.</p>
        </div>
        <div class="modal-footer">
            <button class="cancel-btn" (click)="closeDeleteModal()">Annuler</button>
            <button class="delete-confirm-btn" (click)="confirmDeleteReservation()">Supprimer</button>
        </div>
    </div>
</div>

<!-- Cancel Confirmation Modal -->
<div class="confirmation-modal-overlay" *ngIf="showCancelModal" (click)="closeCancelModal()">
    <div class="confirmation-modal" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h3 class="modal-title">Confirmer l'annulation</h3>
            <button class="close-button" (click)="closeCancelModal()">×</button>
        </div>
        <div class="modal-body">
            <p class="">Êtes-vous sûr de vouloir annuler cette réservation ?</p>
        </div>
        <div class="modal-footer">
            <button class="cancel-btn" (click)="closeCancelModal()">Annuler</button>
            <button class="delete-confirm-btn" (click)="confirmCancelReservation()">Supprimer</button>
        </div>
    </div>
</div>

<!-- Reject Confirmation Modal -->
<div class="confirmation-modal-overlay" *ngIf="showRejectModal" (click)="closeRejectModal()">
    <div class="confirmation-modal" (click)="$event.stopPropagation()">
        <div class="modal-header">
            <h3 class="modal-title">Confirmer le refus</h3>
            <button class="close-button" (click)="closeRejectModal()">×</button>
        </div>
        <div class="modal-body">
            <p class="">Êtes-vous sûr de vouloir refuser cette offre ?</p>
        </div>
        <div class="modal-footer">
            <button class="cancel-btn" (click)="closeRejectModal()">Annuler</button>
            <button class="delete-confirm-btn" (click)="confirmRejectOffer()">Supprimer</button>
        </div>
    </div>
</div>